import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Box, Button, Alert, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { VENDOR_ACCOUNTS_QUERY } from '../graphql/queries';
import VendorServicesPage from './VendorServicesPage';

// Admin > Vendors > Manage services: the vendor's services page, acting for that vendor
export default function AdminVendorServicesPage() {
  const { vendorId } = useParams();
  const navigate = useNavigate();
  const { data, loading } = useQuery(VENDOR_ACCOUNTS_QUERY, { fetchPolicy: 'cache-first' });
  const vendor = (data?.vendorAccounts || []).find(v => v.id === vendorId);

  return (
    <Box>
      <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/dashboard/admin/vendors')} sx={{ mb: 2 }}>
        All vendors
      </Button>
      {loading && !data && <CircularProgress sx={{ display: 'block', mx: 'auto', my: 4 }} />}
      {data && !vendor && <Alert severity="error">Vendor not found.</Alert>}
      {vendor && (
        <>
          <Alert severity="info" sx={{ mb: 2 }}>
            You are managing <strong>{vendor.businessName}</strong> ({vendor.email}). Changes are made on the vendor's behalf.
          </Alert>
          <VendorServicesPage key={vendor.id} vendorUserId={vendor.id} vendorName={vendor.businessName} />
        </>
      )}
    </Box>
  );
}
